/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_EllipsisInputs */

const en_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group...`)
};

const fr_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements...`)
};

const de_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe...`)
};

const it_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo eventi...`)
};

const ru_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий...`)
};

const es_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos...`)
};

const zh_cn2_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组...`)
};

const ja_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループ...`)
};

const hi_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप...`)
};

const pt_pt2_event_group_ellipsis = /** @type {(inputs: Event_Group_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos...`)
};

/**
* | output |
* | --- |
* | "Event Group..." |
*
* @param {Event_Group_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_ellipsis = /** @type {((inputs?: Event_Group_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_ellipsis(inputs)
	if (locale === "de") return de_event_group_ellipsis(inputs)
	if (locale === "it") return it_event_group_ellipsis(inputs)
	if (locale === "ru") return ru_event_group_ellipsis(inputs)
	if (locale === "es") return es_event_group_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_ellipsis(inputs)
	if (locale === "ja") return ja_event_group_ellipsis(inputs)
	if (locale === "hi") return hi_event_group_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_ellipsis(inputs)
	return en_event_group_ellipsis(inputs)
});